import { User } from "../models/User";

export class AuditLog {
    Id: number;
    Tenant: number;
    UserId: number;
    User: User;
    ObjectId: string;
    ObjectName: string;
    Entity: string;
    EntityName: string;
    Action: string;
    Details: string | null;
    HtmlDetails: string | null;
    DateTime: Date;
    Source : string;
}